import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import paths from '../../_helpers/paths';
import useHasAccess from '../../components/useHasAccess';
import permissions from '../../_helpers/permissions';
import { loginModule } from '../LoginPage/LoginDucks';
import { ROLES } from '../../_helpers/Constants';

export default function HomePage() {
  const canViewJournal = useHasAccess(permissions.journalPage);
  const roles = useSelector(state => state[loginModule].user?.roles) || [];

  if (roles.length === 1 && roles[0] === ROLES.ES_FINCENTER) {
    return <Redirect to={paths.contingentCandidatePage} />;
  }

  return <Redirect to={canViewJournal ? paths.journalPage : paths.myTaskPage} />;
}
